import { useQuery } from "@tanstack/react-query";
import { courseschedulesApi, CourseSchedulePreviewResponse } from "../courseSchedulesApi";

export const useCourseSchedulePreview = (courseId: number) => {
  return useQuery<CourseSchedulePreviewResponse>({
    queryKey: ["courseSchedulePreview", courseId],
    queryFn: () => courseschedulesApi.fetchPreview(courseId).then((res) => res.data),
    enabled: !!courseId,
  });
};
